<template>
  <!-- :loading="loading" -->
  <v-btn icon color="deep-orange" @click="openActionSwal">
    <v-icon style="font-size: 20px !important">mdi-archive-cog</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "DeleteArchiveAction",

  props: {
    item: {
      type: Object,
      required: true,
    },
    archiveBody: {
      type: Object,
      default: () => ({}),
    },

    deleteUrl: {
      type: String,
      required: true,
    },

    archiveUrl: {
      type: String,
      required: true,
    },

    deleteMethod: {
      type: String,
      default: "DELETE",
    },

    archiveMethod: {
      type: String,
      default: "POST",
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    async openActionSwal() {
      const result = await this.$swal({
        title: this.$t("labels.choose_action") || "Choose Action",
        text:
          this.$t("labels.choose_delete_or_archive") ||
          "Choose whether you want to delete or archive this item.",
        icon: "question",

        showCancelButton: true,
        showDenyButton: true,

        confirmButtonText: this.$t("labels.archive") || "Archive",
        denyButtonText: this.$t("labels.delete") || "Delete",
        cancelButtonText: this.$t("cancel") || "Cancel",

        confirmButtonColor: "#f59e0b",
        denyButtonColor: "#d33",
        cancelButtonColor: "#777",
      });

      if (result.isConfirmed) {
        await this.confirmAction("archive");
      }

      if (result.isDenied) {
        await this.confirmAction("delete");
      }
    },
    buildFormData(payload) {
      const formData = new FormData();

      Object.keys(payload).forEach((key) => {
        if (payload[key] !== null && payload[key] !== undefined) {
          formData.append(key, payload[key]);
        }
      });

      return formData;
    },

    async confirmAction(action) {
      const isDelete = action === "delete";

      const result = await this.$swal({
        title: this.$t("areYouSure") || "Are you sure?",
        text: isDelete
          ? this.$t("youWillNotBeAbleToGoBackInTheProcess") ||
            "Are you sure you want to delete this item?"
          : this.$t("labels.confirm_archive") ||
            "Are you sure you want to archive this item?",
        icon: "warning",

        showCancelButton: true,
        confirmButtonColor: isDelete ? "#d33" : "#f59e0b",
        cancelButtonColor: "#777",
        confirmButtonText: this.$t("ok") || "OK",
        cancelButtonText: this.$t("cancel") || "Cancel",
      });

      if (!result.isConfirmed && !result.value) return;

      if (isDelete) {
        await this.deleteItem();
      } else {
        if (!this.isPremium()) {
          this.showUpgradePlanAlert();
          return;
        }
        await this.archiveItem();
      }
    },

    async deleteItem() {
      try {
        this.loading = true;

        const response = await this.axios({
          method: this.deleteMethod,
          url: this.deleteUrl,
        });

        await this.$swal({
          icon: "success",
          title:
            response.data?.message ||
            this.$t("labels.deleted_successfully") ||
            "Deleted successfully",
          confirmButtonText: this.$t("ok") || "OK",
        });

        this.$emit("success", {
          action: "delete",
          item: this.item,
          response,
        });
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },

    async archiveItem() {
      // if (!this.isPremium()) {
      //   this.showUpgradePlanAlert();
      //   return;
      // }
      try {
        this.loading = true;

        const formData = this.buildFormData(this.archiveBody);
        console.log("archiveBody", this.archiveBody);

        const response = await this.axios({
          method: this.archiveMethod,
          url: this.archiveUrl,
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        await this.$swal({
          icon: "success",
          title: this.$t("archivedSuccessfully") || "Archived successfully",
          confirmButtonText: this.$t("ok") || "OK",
        });

        this.$emit("success", {
          action: "archive",
          item: this.item,
          response,
        });
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },

    handleError(error) {
      this.$swal({
        icon: "error",
        title: this.$t("labels.cant_complete_action") || "Cant Complete Action",
        text:
          this.$t(`validation.${error.response?.data?.message}`) ||
          this.$t("labels.try_again_later") ||
          "Please try again later",
        confirmButtonText: this.$t("ok") || "OK",
      });
    },
  },
};
</script>
